import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './output.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './auth/fetchInterceptor'
import { getAccess, getRefresh } from './auth/tokenStorage';    
import { refreshAccessToken } from './auth/tokenManager';   
const root = ReactDOM.createRoot(document.getElementById('root'));
(async function bootstrapAuthAndRender() {
  try {
    if (!getAccess() && getRefresh()) {
      await refreshAccessToken(); // при фейле внутри будет logout + редирект
    }
  } catch (_) {
    // ignore: onLogout уже сделал редирект
  } finally {
    root.render(<App />);
    reportWebVitals();
  }
})();
root.render(
  // <React.StrictMode>
    <App />
  // </React.StrictMode>
);
reportWebVitals();
